import { useMutation } from '@tanstack/react-query';
import { getDownloadFile } from '../api/services/account-manager/general/requests';

export const useDownloadFile = () => {
  return useMutation<void, Error, { url: string; filename: string }>(
    ({ url, filename }) => getDownloadFile(url, filename)
  );
};
